import React, { useState } from "react";
import { toast } from "sonner";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SUBJECTS = ["General", "Custom piece", "Collab", "Press", "Returns"];

const ContactPage = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "General",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast("FILL EVERYTHING IN");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast("MESSAGE RECEIVED. WE READ EVERYTHING.");
      setForm({ name: "", email: "", subject: "General", message: "" });
    } catch (err) {
      toast("SOMETHING BROKE. TRY AGAIN OR EMAIL HELLO@DAMAGECULTURE.IN");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="page-contact" className="bg-charcoal text-cream pt-[120px] pb-20">
      <div className="max-w-[1200px] mx-auto px-4 md:px-12">
        <h1 className="font-display uppercase text-6xl sm:text-8xl md:text-9xl leading-none">
          Reach Out
        </h1>
        <p className="font-body text-xl md:text-2xl mt-6 max-w-2xl text-cream/85 leading-relaxed">
          For custom pieces, press, collabs, or just to say hi. We read everything.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-12 lg:gap-20 mt-16">
          {/* Form */}
          <form onSubmit={submit} data-testid="contact-form" className="space-y-5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="font-mono text-[11px] uppercase tracking-widest text-cream/70 block mb-2">
                  Name
                </label>
                <input
                  type="text"
                  value={form.name}
                  onChange={update("name")}
                  data-testid="contact-name"
                  className="dc-input-dark"
                  required
                />
              </div>
              <div>
                <label className="font-mono text-[11px] uppercase tracking-widest text-cream/70 block mb-2">
                  Email
                </label>
                <input
                  type="email"
                  value={form.email}
                  onChange={update("email")}
                  data-testid="contact-email"
                  className="dc-input-dark"
                  required
                />
              </div>
            </div>
            <div>
              <label className="font-mono text-[11px] uppercase tracking-widest text-cream/70 block mb-2">
                Subject
              </label>
              <select
                value={form.subject}
                onChange={update("subject")}
                data-testid="contact-subject"
                className="dc-input-dark"
              >
                {SUBJECTS.map((s) => (
                  <option key={s} value={s} className="bg-charcoal text-cream">
                    {s}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="font-mono text-[11px] uppercase tracking-widest text-cream/70 block mb-2">
                Message
              </label>
              <textarea
                value={form.message}
                onChange={update("message")}
                data-testid="contact-message"
                rows={6}
                className="dc-input-dark resize-none"
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="contact-submit"
              className="bg-cream text-ink font-display uppercase px-8 py-4 tracking-wider hover:bg-dc-red hover:text-cream transition-colors disabled:opacity-50"
            >
              {loading ? "SENDING..." : "SEND"}
            </button>
          </form>

          {/* Direct info */}
          <aside className="space-y-6 font-mono text-xs uppercase tracking-widest text-cream/85">
            <div>
              <p className="text-cream/50 mb-1">Email</p>
              <a href="mailto:hello@damageculture.in" className="hover:text-dc-red">
                hello@damageculture.in
              </a>
            </div>
            <div>
              <p className="text-cream/50 mb-1">Instagram</p>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-dc-red"
              >
                @damageculture
              </a>
            </div>
            <div>
              <p className="text-cream/50 mb-1">Studio</p>
              <p>BANGALORE, INDIA</p>
            </div>
            <div>
              <p className="text-cream/50 mb-1">Hours</p>
              <p>BY APPOINTMENT ONLY</p>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
